export default (siteName) => [
    {
        path: 'invoice',
        name: 'invoice',
        component: () => import('../components/dashboard/Invoice/InvoicePage.vue'),
        meta: {
            title: `發票${siteName}`,
        },
    },
    {
        path: 'invoice/add',
        name: 'invoice-add',
        component: () => import('../components/dashboard/Invoice/InvoiceAddPage.vue'),
        meta: {
            title: `新增發票${siteName}`,
            activeMenu: 'invoice',
        },
    },
    {
        path: 'invoice/:sno/edit',
        name: 'invoice-edit',
        component: () => import('../components/dashboard/Invoice/InvoiceAddPage.vue'),
        meta: {
            title: `修改發票${siteName}`,
            activeMenu: 'invoice',
        },
    },
    {
        path: 'invoice/:sno/pdf',
        name: 'invoice-pdf',
        component: () => import('../components/dashboard/Invoice/InvoicePdfPage'),
        meta: {
            title: `發票 Invoice PDF${siteName}`,
            activeMenu: 'invoice',
        },
    },
    {
        path: 'invoice/:sno',
        name: 'invoice-detail',
        component: () => import('../components/dashboard/Invoice/InvoicePage.vue'),
        meta: {
            title: `發票明細${siteName}`,
            activeMenu: 'invoice',
        },
    },
];
